


























































import Vue from 'vue'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import { Account } from '@/modules/Account/interfaces/account'
import { Contact } from '@/modules/Contact/interfaces/contact'
import ContactDialog from '@/modules/Contact/scripts/contact-dialog'
import RelationFormDialog from '@/modules/AccountContactRelation/components/RelationFormDialog.vue'
import RelationDialog from '@/modules/AccountContactRelation/scripts/account-contact-relation-dialog'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import { getContacts } from '@/modules/Contact/gql/contact.gql'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { formatPhoneNumber } from '@/utils/phoneNumberFormat'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    RelationFormDialog
  }
})
export default class AccountDetailContact extends mixins(AccountDialog, ContactDialog, RelationDialog) {
  @Prop({ type: Object as () => Account }) readonly account!: Account

  accountId: number | null = null

  tableColumn = [
    { field: 'name', title: 'Contact Name', slots: { default: 'name_default' }, sortable: true, resizable: true },
    { title: 'Title',
      field: 'title',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.title ? row.title : '-')
        ]
      }
      },
      resizable: true
    },
    { title: 'Phone',
      field: 'phone',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.phone ? formatPhoneNumber(row.phone, row.countryCode) : '-')
        ]
      }
      },
      resizable: true,
      sortable: true
    },
    { title: 'Ext',
      field: 'extensionNumber',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.extensionNumber ? row.extensionNumber : '-')
        ]
      }
      },
      width: 80,
      resizable: true,
      sortable: false
    },
    { title: 'Fax',
      field: 'fax',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.fax ? formatPhoneNumber(row.fax, row.faxCountryCode, row.faxExtensionNumber) : '-')
        ]
      }
      },
      resizable: true,
      sortable: false
    },
    { title: 'Email',
      field: 'email',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.email ? row.email : '-')
        ]
      }
      },
      sortable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    name: 'NAME',
    phone: 'PHONE',
    email: 'EMAIL'
  }

  contacts: Contact[] = []

  @Watch('account', { deep: true })
  onAccountUpdated () {
    this.getContacts()
  }

  mounted () {
    this.getContacts()
  }

  async getContacts () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getContacts,
        variables: {
          filter: {
            accountId: Number(this.account.id)
          },
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          },
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.contacts = result.data.getContacts.contacts
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getContacts.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getContacts()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getContacts()
  }

  routeTo (name: string, params: any) {
    this.$router.push({
      name,
      params
    })
  }

  routeToRelationship (e: Event, item: any) {
    e.preventDefault()
    e.stopPropagation()
    this.routeTo('AccountContactRelationDetail', {
      id: item.relation.id
    })
  }

  newContact (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.accountId = Number(this.account.id)
    this.showContactEditDialog(e)
  }

  newRelation (e: Event) {
    e.preventDefault()
    e.stopPropagation()
    this.showRelationEditDialog(e)
  }

  clearForm () {
    this.accountId = null
    this.hideContactEditDialog()
  }

  @Emit('refresh')
  onFormSuccess () {
    // do nothing
  }

  routeToDetail (item: any) {
    return {
      name: 'ContactDetailDetail',
      params: {
        id: item.id
      }
    }
  }

  routeToAccountDetail (item: any) {
    return {
      name: 'AccountDetailDetail',
      params: {
        id: item.accountName.id
      }
    }
  }

  async deleteContactConfirm () {
    await this.deleteContactPost()
    this.onFormSuccess()
  }
}
